import React from 'react';
import snapshot from '../data/pricing-snapshot.json';

// Claude 按 opus → sonnet → haiku 排，同级及其他厂商按名称倒序（与模型库一致）
function tierOf(name) {
  if (name.includes("opus")) return 0;
  if (name.includes("sonnet")) return 1;
  if (name.includes("haiku")) return 2;
  return 3;
}

function Marquee() {
  const items = (snapshot.data || [])
    .map(m => m.model_name)
    .sort((a, c) => (tierOf(a) - tierOf(c)) || c.localeCompare(a));

  return (
    <div className="marquee" aria-hidden="true">
      <div className="marquee-track">
        {[...items, ...items].map((x, i) => (
          <span key={i} className="marquee-item">
            <span className="mq-bullet">◆</span>{x}
          </span>
        ))}
      </div>
    </div>
  );
}

export default Marquee;
